import { IStopBasicForCarrier, IStopDetailedForCarrier } from '../stop';
import { IFreightBasicForCarrier, IFreightDetailedForCarrier } from './freight-carrier.model';

export function transformToIFreightBasicFromIFreightDetailForCarrier(
  freightDetailed: IFreightDetailedForCarrier,
): IFreightBasicForCarrier {
  return {
    id: freightDetailed.id,
    status: freightDetailed.status,
    reference: freightDetailed.reference,

    stopsBasic: Array.isArray(freightDetailed.stopsDetailed)
      ? freightDetailed.stopsDetailed.map(transformStopDetailToStopBasicForCarrier)
      : [],

    nextStopId: freightDetailed.nextStopId,
    nextStopType: freightDetailed.nextStopType,
    nextStopStatus: freightDetailed.nextStopStatus,

    vehicles: freightDetailed.vehicles || [],
    drivers: freightDetailed.drivers || [],
    invoiceList: freightDetailed.invoiceList || [],

    billingStatus: freightDetailed.billingStatus,
    fastPaymentForCarrierStatus: freightDetailed.fastPaymentForCarrierStatus,
    scheduledKm: freightDetailed.scheduledKm,
    price: freightDetailed.price,
    hasPendingDoc: freightDetailed.hasPendingDoc,
    deliveryNoteInPaperRequired: freightDetailed.deliveryNoteInPaperRequired,
    deliveryNoteInPaperReceived: freightDetailed.deliveryNoteInPaperReceived,
    numberOfStops: freightDetailed.numberOfStops,
  };
}

function transformStopDetailToStopBasicForCarrier(stopDetailed: IStopDetailedForCarrier): IStopBasicForCarrier {
  return {
    id: stopDetailed.id,
    position: stopDetailed.position,
    type: stopDetailed.type,
    since: stopDetailed.since,
    until: stopDetailed.until,
    status: stopDetailed.status,
    address: stopDetailed.address,
  };
}
